import { Controller } from "@hotwired/stimulus"
import { toggleReply, cancelReply, submitComment, submitReplyComment } from "../shared/comment_replies"

export default class extends Controller {
  static targets = ["icon", "count", "section", "list", "form", "textarea", "replyForm"]
  static values = { eventId: Number, expanded: Boolean }

  connect() {
    this.expandedValue = false
    this.currentReplyForm = null
    this.pendingCommentId = null

    const hash = window.location.hash
    const commentMatch = hash.match(/^#event-(\d+)-comment-(\d+)$/)
    if (commentMatch && parseInt(commentMatch[1]) === this.eventIdValue) {
      this.pendingCommentId = parseInt(commentMatch[2])
      this.expand()
    } else if (hash === `#event-${this.eventIdValue}`) {
      this.expand()
    }
  }

  toggle() {
    if (this.expandedValue) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    if (!this.hasListTarget) {
      this.loadComments()
    }
    this.sectionTarget.classList.remove("d-none")
    this.expandedValue = true
  }

  collapse() {
    this.sectionTarget.classList.add("d-none")
    this.expandedValue = false
  }

  loadComments() {
    const url = `/events/${this.eventIdValue}/comments`

    fetch(url, {
      headers: {
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text()
      })
      .then(html => {
        this.sectionTarget.innerHTML = html
        if (this.pendingCommentId) {
          const el = this.sectionTarget.querySelector(`[data-comment-id="${this.pendingCommentId}"]`)
          if (el) el.scrollIntoView({ behavior: 'smooth' })
          this.pendingCommentId = null
        }
      })
      .catch(error => {
        console.error('Error loading comments:', error)
      })
  }

  toggleReply(event) {
    toggleReply(this, event, "event-comments")
  }

  cancelReply(event) {
    cancelReply(this, event)
  }

  submit(event) {
    event.preventDefault()

    const body = this.textareaTarget.value.trim()
    if (!body) return

    const url = `/events/${this.eventIdValue}/comments`

    submitComment(url, "body", body)
      .then(data => {
        if (data.success) {
          this.textareaTarget.value = ""
          this.countTarget.textContent = data.comments_count
          this.listTarget.insertAdjacentHTML('afterbegin', data.html)
        }
      })
      .catch(error => {
        console.error('Error creating comment:', error)
      })
  }

  submitReply(event) {
    event.preventDefault()

    const form = event.currentTarget
    const textarea = form.querySelector('textarea')
    const body = textarea.value.trim()
    if (!body) return

    const parentId = form.dataset.parentId
    const url = `/events/${this.eventIdValue}/comments`

    submitReplyComment(url, "body", body, parentId)
      .then(data => {
        if (data.success) {
          const commentItem = this.element.querySelector(`[data-comment-id="${parentId}"]`)
          const repliesContainer = commentItem.querySelector('.replies-container')
          repliesContainer.insertAdjacentHTML('beforeend', data.html)

          if (this.currentReplyForm) {
            this.currentReplyForm.classList.add('d-none')
            this.currentReplyForm.innerHTML = ''
            this.currentReplyForm = null
          }
        }
      })
      .catch(error => {
        console.error('Error creating reply:', error)
      })
  }
}
